import { UpdateFeatureDc } from "@evergis/api";
import { api } from "../../evergis/api";
import { FeatureDcExtended } from "../selectFeatures/types";
import { Positions } from "../geometryEditor/geometryEditor";
import { UnknownGeometry } from "../../interfaces/geometry";

export const apiGetFeatureById = async (
  featureId: string,
  layerName: string,
  srid?: number,
): Promise<FeatureDcExtended> => {
  const feature = await api.layers.getById({
    name: layerName,
    id: featureId,
    wkid: srid,
  });

  return {
    ...feature,
    geometry: {
      type: feature.geometry.type,
      sr: feature.geometry.sr,
      coordinates: (feature.geometry as UnknownGeometry).coordinates as Positions,
    },
    layer: layerName,
  };
};

export const apiUpdateFeature = async (layerName: string, updateFeature: UpdateFeatureDc) => {
  await api.layers.updateFeature(layerName, [updateFeature]);
};
